import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { StickyBar } from "./StickyBar";
import { JsonLd } from "./JsonLd";
import { useSettings } from "../hooks";

export function Layout({ children, transparan = false, mesaj }) {
  const s = useSettings();
  const org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Özalp İnşaat",
    url: window.location.origin,
    telephone: s?.phone,
    email: s?.email,
    address: { "@type": "PostalAddress", addressLocality: "İstanbul", addressCountry: "TR", streetAddress: s?.address },
    areaServed: "İstanbul Anadolu Yakası",
  };
  return (
    <div className="ozalp">
      <JsonLd id="org" data={org} />
      <SiteHeader transparan={transparan} />
      <StickyBar mesaj={mesaj} />
      {children}
      <SiteFooter />
    </div>
  );
}
